import { getFlattenPronounce } from "common/character/character_common";
import { CharacterResult } from "common/character/dto/CharacterResult";
import { ItemTag } from "common/tag/dto/ItemTag";

export const excludeIdsLettersFilter = (
  characters: CharacterResult[],
  excludeIds?: string[],
  excludeLetters?: string[]
): CharacterResult[] => {
  let result = [...characters];
  if (excludeIds && excludeIds.length > 0) {
    result = result.filter(
      (character: CharacterResult) => !excludeIds.includes(character.id)
    );
  }
  if (excludeLetters && excludeLetters.length > 0) {
    result = result.filter(
      (character: CharacterResult) => !excludeLetters.includes(character.letter)
    );
  }

  return result;
};

export const searchSelectResults = (
  characters: CharacterResult[],
  excludeIds?: string[],
  excludeLetters?: string[],
  searchText?: string
): CharacterResult[] => {
  let result = [...characters];
  if (excludeIds || excludeLetters) {
    result = excludeIdsLettersFilter(result, excludeIds, excludeLetters);
    result = sortByPronounce(result);
  }

  return result;
};

const sortByPronounce = (characters: CharacterResult[]): CharacterResult[] => {
  const result = characters.sort(
    (character1: CharacterResult, character2: CharacterResult) => {
      const flattenPronounce1 = getFlattenPronounce(character1.pronounce);
      const flattenPronounce2 = getFlattenPronounce(character2.pronounce);
      let cmp = flattenPronounce1.length - flattenPronounce2.length;

      return cmp;
    }
  );

  return result;
};

export const showSearchSelect = (
  characterSelection: CharacterResult
): boolean => {
  let result: boolean = false;
  if (characterSelection.id !== "") {
    result = true;
  }

  return result;
};

export const searchSelectInitial = (
  topicId?: string,
  tags?: ItemTag[]
): any => {
  const result: any = {
    limit: 20,
    skip: 0,
  };
  if (typeof topicId !== "undefined") {
    result.topicId = topicId;
  }
  if (typeof tags !== "undefined") {
    result.tags = tags;
  }

  return result;
};
